import {
  LOADING_DATA,
  SET_SHEETS,
  LOADING_COMPOSERS,
  SET_COMPOSERS,
  RESET_DATA,
  SET_PAGE_SHEETS,
  INCREMENT_SHEET_PAGE,
  DECREMENT_SHEET_PAGE,
  SET_SHEET_PAGE,
  SET_TOTAL_SHEET_PAGES,
  SET_PAGE_COMPOSERS,
  SET_TOTAL_COMPOSER_PAGES,
  INCREMENT_COMPOSER_PAGE,
  DECREMENT_COMPOSER_PAGE,
  SET_COMPOSER_PAGE,
  SET_USERS_DATA,
  UPDATE_COMPOSER_DATA
} from "../types";
import axios from "axios";

import { store } from "../store";
import { logoutUser } from "./userActions";
import { checkAuthErr } from "../../Utils/httpUtils";

// Get all Sheets
export const getSheets = () => (dispatch) => {
  dispatch({ type: LOADING_DATA });
  axios
    .get("/sheets")
    .then((res) => {
      dispatch({
        type: SET_SHEETS,
        payload: res.data.rows,
      });
    })
    .catch((err) => {
      if (err.request.status === 401) {
        store.dispatch(logoutUser());
        window.location.href = "/login";
      }
      console.log(err);

      dispatch({
        type: SET_SHEETS,
        payload: [],
      });
    });
};

/* Page navigation */
export const incrementSheetPage = () => (dispatch) => {
  dispatch({ type: INCREMENT_SHEET_PAGE });
};

export const incrementComposerPage = () => (dispatch) => {
  dispatch({ type: INCREMENT_COMPOSER_PAGE });
};

export const decrementSheetPage = () => (dispatch) => {
  dispatch({ type: DECREMENT_SHEET_PAGE });
};

export const decrementComposerPage = () => (dispatch) => {
  dispatch({ type: DECREMENT_COMPOSER_PAGE });
};

export const setComposerSortOrder = (order) => ({
  type: "SET_COMPOSER_SORT_ORDER",
  payload: order,
});

export const setComposerViewMode = (mode) => ({
  type: "SET_COMPOSER_VIEW_MODE",
  payload: mode,
});

export const setSheetSortOrder = (order) => ({
  type: "SET_SHEET_SORT_ORDER",
  payload: order,
});

export const setSheetViewMode = (mode) => ({
  type: "SET_SHEET_VIEW_MODE",
  payload: mode,
});

export const setSheetPage = (page) => (dispatch) => {
  dispatch({ type: SET_SHEET_PAGE, payload: page });
};

export const setComposerPage = (page) => (dispatch) => {
  dispatch({ type: SET_COMPOSER_PAGE, payload: page });
};

export const setSheetPageSize = (size) => ({
  type: "SET_SHEET_PAGE_SIZE",
  payload: size,
});

export const setComposerPageSize = (size) => ({
  type: "SET_COMPOSER_PAGE_SIZE",
  payload: size,
});

export const getSheetPage = (data = {}, _callback) => (dispatch) => {
    dispatch({ type: LOADING_DATA });

    let bodyFormData = new FormData();
    bodyFormData.append("page", data.page === undefined ? 1 : data.page);
    bodyFormData.append("limit", 50);
    bodyFormData.append(
      "sort_by",
      data.sortBy === undefined ? "updated_at desc" : data.sortBy
    );

    if (data.composer !== undefined) {
      bodyFormData.append("composer", data.composer);
    }

    axios
      .post("/sheets", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        dispatch({
          type: SET_PAGE_SHEETS,
          payload: res.data.rows,
          page: data.page,
          composer: data.composer,
        });
        dispatch({
          type: SET_TOTAL_SHEET_PAGES,
          payload: res.data.total_pages,
        });
		  if (typeof _callback === "function") {
			_callback();
		  }
      })
      .catch((err) => {
        if (err.request && err.request.status === 401) {
          store.dispatch(logoutUser());
          window.location.href = "/login";
        }
        console.log(err);
      });
  };

export const getComposerPage = (data = {}, _callback) => (dispatch) => {
    dispatch({ type: LOADING_DATA });

    let bodyFormData = new FormData();
    bodyFormData.append("page", data.page === undefined ? 1 : data.page);
    bodyFormData.append("limit", 50);
    bodyFormData.append(
      "sort_by",
      data.sortBy === undefined ? "updated_at desc" : data.sortBy
    );

    axios
      .post("/composers", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        dispatch({
          type: SET_PAGE_COMPOSERS,
          payload: res.data.rows,
          page: data.page,
        });
        dispatch({
          type: SET_TOTAL_COMPOSER_PAGES,
          payload: res.data.total_pages,
        });

		  if (typeof _callback === "function") {
			_callback();
		  }      })
      .catch((err) => {
        console.log(err);

        if (err.request.status === 401) {
          store.dispatch(logoutUser());
          window.location.href = "/login";
        }
      });
  };

export const getComposers = () => (dispatch) => {
  dispatch({ type: LOADING_COMPOSERS });
  axios
    .get("/composers")
    .then((res) => {
      dispatch({
        type: SET_COMPOSERS,
        payload: res.data.rows,
      });
    })
    .catch((err) => {
      if (err.request.status === 401) {
        store.dispatch(logoutUser());
        window.location.href = "/login";
      }

      console.log(err);
      dispatch({
        type: SET_COMPOSERS,
        payload: [],
      });
    });
};

export const uploadSheet = (data, _callback) => (dispatch) => {
  let bodyFormData = new FormData();

  // Iteriert dynamisch über alle Keys im data-Objekt
  Object.entries(data).forEach(([key, value]) => {
    // Verhindert das Senden von "undefined" oder "null" als String an das Backend
    if (value !== undefined && value !== null) {
      bodyFormData.append(key, value);
    }
  });

  axios
    .post("/upload", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      _callback();
    })
    .catch((err) => {
      if (err.request && err.request.status === 401) {
        // Nutze hier das übergebene dispatch statt dem globalen store.dispatch
        dispatch(logoutUser());
        window.location.href = "/login";
      }
      console.error(err);
    });
};

export const updateSheet = (data, origSheetName, _callback) => (dispatch) => {
  let bodyFormData = new FormData();
  bodyFormData.append("uploadFile", data.uploadFile);
  bodyFormData.append("sheetName", data.sheetName);
  bodyFormData.append("composer", data.composer);
  bodyFormData.append("releaseDate", data.releaseDate);
  bodyFormData.append("information_text", data.informationText);
  bodyFormData.append("sheet_image_url", data.sheetImageUrl || "");
  bodyFormData.append("composer_image_url", data.composerImageUrl || "");
  bodyFormData.append("key_signature", data.keySignature || "");
  bodyFormData.append("tempo", data.tempo || 0);
  bodyFormData.append("duration", data.duration || "");
  bodyFormData.append("instrument", data.instrument || "");
  bodyFormData.append("youtube_link", data.youtubeLink || "");
  bodyFormData.append("collection", data.collection || ""); 
  bodyFormData.append("mbId", data.mbId || ""); 
  bodyFormData.append("itunesId", data.itunesId || "");
  bodyFormData.append("category", data.category || "");
  bodyFormData.append("trackViewUrl", data.trackViewUrl || "");
    
  axios
    .put(`/sheet/${origSheetName}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      _callback();
    })
    .catch((err) => {
      if (err.request.status === 401) {
        store.dispatch(logoutUser());
        window.location.href = "/login";
      }

      console.log(err);
    });
};

export const deleteSheet = (origSheetName, _callback) => (dispatch) => {
  axios
    .delete(`/sheet/${origSheetName}`)
    .then((res) => {
      _callback();
    })
    .catch((err) => {
      if (err.request.status === 401) {
        store.dispatch(logoutUser());
        window.location.href = "/login";
      }
      console.log(err);
    });
};

export const editComposer = (bodyFormData, ComposerSafeName) => (dispatch) => {
  console.log("--- REDUX ACTION: editComposer abgefeuert (Reines CamelCase) ---");

  axios
    .put(`/composer/${ComposerSafeName}`, bodyFormData)
    .then((res) => {
      console.log("✅ Erfolgreich in SQLite-Datenbank gespeichert!", res.data);
      
      // Sendet die aktualisierten Daten an den Reducer, um die Hauptseite live upzudaten
      dispatch({
        type: UPDATE_COMPOSER_DATA,
        payload: res.data
      });
    })
    .catch((err) => {
      console.error("❌ Kritischer Fehler beim Übertragen der Formulardaten:", err);
    });
};

export const deleteComposer = (name, _callback) => (dispatch) => {
  axios
    .delete(`/composer/${name}`)
    .then(() => {
      _callback();
    })
    .catch((err) => {
      if (err.request.status === 401) {
        store.dispatch(logoutUser());
        window.location.href = "/login";
      }
      console.log(err);
    });
};

export const getTagSheets = (tagName, _callback) => (dispatch) => {
  let bodyFormData = new FormData();
  bodyFormData.append("tagValue", tagName);

  axios
    .post("/tag", bodyFormData)
    .then((res) => {
      _callback(res.data);
    })
    .catch((err) => {
      if (err.request && err.request.status === 401) {
        store.dispatch(logoutUser());
        window.location.href = "/login";
      }
      console.log(err);
    });
};

export const addNewTag = (tagName, sheetName, _callback) => (dispatch) => {
  let bodyFormData = new FormData();
  bodyFormData.append("tagValue", tagName);

  axios
    .post(`/tag/sheet/${sheetName}`, bodyFormData)
    .then((res) => {
      store.dispatch(resetData());
      window.location.reload();
    })
    .catch((err) => {
      if (err.request.status === 401) {
        store.dispatch(logoutUser());
        window.location.href = "/login";
      }
      console.log(err);
    });
};

export const deleteTag = (tagName, sheetName, _callback) => (dispatch) => {
  let bodyFormData = new FormData();
  bodyFormData.append("tagValue", tagName);

  axios
    .post(`/tag/delete/sheet/${sheetName}`, bodyFormData)
    .then((res) => {
      store.dispatch(resetData());
      window.location.reload();
    })
    .catch((err) => {
      if (err.request.status === 401) {
        store.dispatch(logoutUser());
        window.location.href = "/login";
      }
      console.log(err);
    });
};

export const addNewCategory = (categoryName, sheetName, _callback) => (dispatch) => {
  let bodyFormData = new FormData();
  bodyFormData.append("categoryValue", categoryName);

  axios
    .post(`/category/sheet/${sheetName}`, bodyFormData)
    .then((res) => {
      store.dispatch(resetData());
      window.location.reload();
    })
    .catch((err) => {
      if (err.request.status === 401) {
        store.dispatch(logoutUser());
        window.location.href = "/login";
      }
      console.log(err);
    });
};

export const deleteCategory = (categoryName, sheetName, _callback) => (dispatch) => {
  let bodyFormData = new FormData();
  bodyFormData.append("categoryValue", categoryName);

  axios
    .post(`/category/delete/sheet/${sheetName}`, bodyFormData)
    .then((res) => {
      store.dispatch(resetData());
      window.location.reload();
    })
    .catch((err) => {
      if (err.request.status === 401) {
        store.dispatch(logoutUser());
        window.location.href = "/login";
      }
      console.log(err);
    });
};

export const editInfoText = (infoData, sheetName) => (dispatch) => {
  // ⭐ DIAGNOSE-LOG: Hier sehen Sie live in der F12-Konsole, ob React die Daten überhaupt losschickt!
  console.log("--- REDUX ACTION: editInfoText abgefeuert ---");
  console.log("Übergebener sheetName (URL):", sheetName);
  console.log("Inhalt von infoData aus dem Formular:", infoData);

  // Wir verpacken die Daten exakt so, wie das Go-Backend es im Struct erwartet
  const body = {
    information_text: infoData.infoText,
    tempo: parseInt(infoData.tempo, 10) || 0,
    duration: infoData.duration,
    instrument: infoData.instrument,
    collection: infoData.collection,
    mbId: infoData.mbId,
    itunesId: infoData.itunesId ? String(infoData.itunesId) : "",
	releaseDate: infoData.releaseDate && infoData.releaseDate !== "undefined" 
      ? infoData.releaseDate.substring(0, 10) 
      : "1999-12-31" ,
    infoText: infoData.infoText,
    keySignature: infoData.keySignature,
    youtubeLink: infoData.youtubeLink,
    category: infoData.category,
	trackViewUrl: infoData.trackViewUrl,
  };

  console.log("Finale HTTP-Body-Nutzlast (Payload):", body);
  console.log("-------------------------------------------");

  axios
    .put(`/sheet/${sheetName}`, body)
    .then((res) => {
      console.log("ERFOLG: Backend hat geantwortet und gespeichert!", res.data);
      
      // Zusätzliches Update für das aktive Sheet im Store, falls vorhanden
      dispatch({
        type: "UPDATE_SHEET_DATA",
        payload: res.data
      });
    })
    .catch((err) => {
      console.error("KRITISCHER FEHLER beim Senden an /sheet/ " + sheetName, err);
    });
};

export const updateSheetRatingInStore = (safeSheetName, ratingAvg, ratingCount) => (dispatch) => {
  dispatch({
    type: "UPDATE_SHEET_RATING", // Stelle sicher, dass der Typ eindeutig ist
    payload: {
      safeSheetName,
      ratingAvg,
      ratingCount,
    },
  });
};

export const searchData = (searchValue, _callback) => (dispatch) => {
  axios
    .get(`/search/${searchValue}`)
    .then((res) => {
      _callback(res.data);
    })
    .catch((err) => {
      if (err.request.status === 401) {
        store.dispatch(logoutUser());
        window.location.href = "/login";
      }
      console.log(err);
    });
};

export const getUsersData = () => (dispatch) => {
  dispatch({ type: LOADING_DATA })
  axios
    .get("/users")
    .then(res => {
      dispatch({
        type: SET_USERS_DATA,
        payload: res.data
      })
    }).catch(err => checkAuthErr(err, dispatch))
}

export const resetData = () => (dispatch) => {
  dispatch({ type: RESET_DATA });
};
